// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__J_Vde","title":"card_title__uNvoA","subtitle":"card_subtitle__NxhQi"};